module.exports = __webpack_public_path__ + "img/5.b481e7d0.png";